const StatusEnum = Object.freeze({
  FINISHED: 1,
  INTERRUPTED: 2,
  ACTIVE: 3
});

export default (StatusEnum);
